import { FormattedMessage } from 'react-intl';
import { forwardRef, type ReactNode } from 'react';
import type { BackdropProps } from '@mui/material';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import loaderLogoSrc from 'assets/images/idecon-loader-logo.png';

export type LoadingBackdropProps = BackdropProps & {
  statusLabel?: ReactNode;
};

const LoadingBackdrop = forwardRef<HTMLDivElement, LoadingBackdropProps>(function LoadingBackdrop(
  { children, open, statusLabel, sx, ...backdropProps },
  ref
) {
  return (
    <>
      <Backdrop
        ref={ref}
        open={open}
        sx={[
          {
            display: 'flex',
            flexDirection: 'column',
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          },
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
        {...backdropProps}>
        <img src={loaderLogoSrc} alt="" />
        <CircularProgress color="inherit" />
        {children}
      </Backdrop>
      {open ? (
        <Box
          component="span"
          role="status"
          sx={{
            position: 'absolute',
            width: 1,
            height: 1,
            p: 0,
            m: -1,
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            whiteSpace: 'nowrap',
            border: 0,
          }}>
          {statusLabel ?? <FormattedMessage id="autocomplete.loadingText" defaultMessage="Yükleniyor..." />}
        </Box>
      ) : null}
    </>
  );
});

export default LoadingBackdrop;
